import { render, staticRenderFns } from "./word-sorting-panel.vue?vue&type=template&id=28fb43f8&"
import script from "./word-sorting-panel.vue?vue&type=script&lang=js&"
export * from "./word-sorting-panel.vue?vue&type=script&lang=js&"
import style0 from "./word-sorting-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fb43f8')) {
      api.createRecord('28fb43f8', component.options)
    } else {
      api.reload('28fb43f8', component.options)
    }
    module.hot.accept("./word-sorting-panel.vue?vue&type=template&id=28fb43f8&", function () {
      api.rerender('28fb43f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-sorting-panel.vue"
export default component.exports